var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("notification-popover", {
    attrs: {
      triggers: "hover",
      container: "#main-content",
      placement: "right",
      "custom-class":
        "latest-changelog-popover board-changelog-details-popover",
    },
    on: { show: _vm.handleShowChangelog },
    scopedSlots: _vm._u([
      {
        key: "popoverTarget",
        fn: function () {
          return [
            _c("icon", {
              staticClass: "clickable",
              attrs: { name: "archive" },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "popoverContent",
        fn: function () {
          return [
            _vm.loading
              ? _c("board-changelog-item-loader")
              : _c(
                  "div",
                  {
                    staticClass: "overflow-auto",
                    staticStyle: { "max-height": "25rem" },
                    on: { scroll: _vm.loadMore },
                  },
                  [
                    _c("changelog-list", {
                      attrs: {
                        "changelog-list": _vm.currentProfileLastChanges,
                        "user-details": _vm.userDetails,
                        "board-id": _vm.boardId,
                        origin: "client-profile",
                      },
                    }),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }